import DittoModel from './ditto-new'

export default class PunchIn extends DittoModel {}
